import { mapGetters } from 'vuex'
import moment from 'moment'
import config from '@/config'
import CustomerItemValue from './CustomerItemValue'
import EditCustomerValue from './../EditCustomerValue'
import EditCustomerSchool from './../EditCustomerSchool'
import specialtext from '@/components/elements/specialtext'
import Tags from '@/components/elements/Tags'
import ChannelLabel from '@/components/elements/ChannelLabel'
import SahapanAddManual from './../customize/sahapan/SahapanAddManual'
import api from '@/api'
import verandaApi from '@/api/veranda'

export default {
  props: {
    value: {
      default: undefined
    },
    getuseronly: {
      default: false
    },
    pageid: {
      default: undefined
    },
    loaduser: {
      default: true
    },
    gender: {
      default: null
    }
  },
  data: function () {
    return {
      sahapandialog: true,
      loading: true,
      user: {},
      isEditTag: false,
      isEditSession: false,
      usertag: '',
      profile_pic: '',
      saveloading: false,
      toauser: {
        paysolutionmerchantid: '',
        fillgood_token: '',
        shop_id: ''
      },
      toacrmUser: {
        email: '',
        phone: ''
      },
      currentpageid: null,
      userSession: null,
      tagOptions: [],
      statusOptions: [],
      updateSearchTagTimeout: null,
      updateSearchStatusTimeout: null,
      limit: 10,
      offset: 0,
      satisfactionHistory: [],
      headers: [
        {
          text: 'วันที่ทำแบบประเมิน',
          value: 'timestamp',
          sortable: false
        },
        { text: 'คะแนนความพึงพอใจ', value: 'satisfaction_score', sortable: false },
        { text: 'คำแนะนำ', value: 'feedback', sortable: false }
      ],
      pagetmp: 1,
      pageNumber: 1,
      total: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      showCopy: false
    }
  },
  components: {
    CustomerItemValue,
    EditCustomerValue,
    EditCustomerSchool,
    specialtext,
    SahapanAddManual,
    Tags,
    ChannelLabel
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab',
      currentLang: 'currentLang'
    }),
    json_variable() {
      if (this.user && this.user.json_variable) {
        return JSON.parse(this.user.json_variable)
      } else {
        return {}
      }
    },
    questionmessages() {
      if (this.value && this.$store.state.niveapage.includes(this.user.pageid)) {
        return this.value.questionmessages.split(';;')
      }
    },
    isBU() {
      return this.$store.state.pageBU.includes(this.selectedBot.pageid)
    },
    filterIntent: function () {
      var vm = this
      if (vm.user && vm.user.intentlist) {
        try {
          return vm.user.intentlist.sort(function (a, b) {
            if (parseInt(a[1]) > parseInt(b[1])) {
              return -1
            }

            if (parseInt(a[1]) < parseInt(b[1])) {
              return 1
            }

            return 0
          })
        } catch (error) {
          console.error(error)
          return []
        }
      } else {
        return []
      }
    },
    userLocale: function () {
      var vm = this
      return config.locale.find(function (locale) {
        if (vm.user.locale == locale.value) {
          return locale.title
        }
      })
    },
    tags: function () {
      var vm = this
      if (vm.user.tags !== '' && vm.user.tags != null) {
        var usertags = vm.user.tags.split(',')
        return usertags
      } else {
        return []
      }
    },
    usertags: {
      get() {
        let vm = this
        if (vm.user && vm.user.tags && vm.user.tags !== '') {
          var usertags = []

          usertags = vm.user.tags.split(',')
          var result = []
          if (usertags) {
            result = usertags.map(function (tag) {
              return { text: tag }
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          result = value.map(function (tag) {
            return tag.text
          })
        }
        vm.user.tags = result.join(',')
      }
    },
    shoplink() {
      var url = ''
      if (window.location.href.includes('cms.zwiz.ai')) {
        url = 'https://shopv2.zwiz.app'
      } else if (
        window.location.href.includes('enterprise.zwiz.ai') ||
        window.location.href.includes('enterprise.zwiz.app') ||
        window.location.href.includes('staging.zwiz.ai') ||
        window.location.href.includes('cityfreshtest.zwiz.ai') ||
        this.selectedBot.theme == 'nvbb'
      ) {
        url = 'https://shopcommu.zwiz.app'
      } else if (window.location.href.includes('localhost')) {
        url = 'https://shopv2.zwiz.app'
      } else {
        return false
      }

      var userid =
        this.$route.name == 'allinonechat'
          ? this.$store.state.livechat.pageid
          : this.selectedBot.pageid

      url =
        url +
        `/ecommerce/${userid}?userid=${this.user.id}&sessiontoken=${this.user.sessiontoken}&lang=${
          this.currentLang || 'th'
        }&category=all&from=livechat&ref=${this.$store.state.userid}`
      return url
    },
    userRealname: {
      get() {
        if (this.user && this.user.realname) {
          return this.user.realname
        } else
          return (
            (this.user.first_name ? this.user.first_name : '') +
            (this.user.last_name ? ' ' + this.user.last_name : '')
          )
      }
    },
    ableToEditCustomer() {
      if (this.$store.state.nestlePages.some((page) => page.pageid == this.user.pageid)) {
        return this.$store.state.userid == 'zwizadmin' || false
      }
      return true
    },
    pageLength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },

  async mounted() {
    if (!this.$store.state.tags) {
      const tags = await this.getUserTagList()
      this.$store.state.tags = tags || []
    }

    if (!this.$store.state.status) {
      const status = await this.getUserStatusList()
      this.$store.state.status = status || []
    }

    this.tagOptions = this.$store.state.tags || []
    this.statusOptions = this.$store.state.status || []

    if (this.selectedBot.theme == 'toacrm') {
      this.getMemberToa()
    }

    if (['veranda_new', 'verso'].includes(this.selectedBot.theme)) {
      this.handleGetVerandaSatisfactionHistory()
    }

    this.getuserDetail()
    // this.user = this.value
    // this.cached_tag = this.user.tags

    this.currentpageid = this.user.pageid
  },
  methods: {
    handleCopyUserId() {
      let vm = this
      vm.showCopy = true
    },
    handleErrorCopyUserId() {},
    async onSearchStatus({ event, onComplete }) {
      const vm = this
      if (vm.updateSearchStatusTimeout) {
        clearTimeout(vm.updateSearchStatusTimeout)
      }
      vm.updateSearchStatusTimeout = setTimeout(async () => {
        try {
          const status = await vm.getUserStatusList(event)
          onComplete(status)
        } catch (error) {
          console.error(error)
        }
        vm.updateSearchStatusTimeout = null
      }, 3000)
    },
    async onSearchTag({ event, onComplete }) {
      const vm = this
      if (vm.updateSearchTagTimeout) {
        clearTimeout(vm.updateSearchTagTimeout)
      }
      vm.updateSearchTagTimeout = setTimeout(async () => {
        try {
          const tags = await vm.getUserTagList(event)
          onComplete(tags)
        } catch (error) {
          console.error(error)
        }
        vm.updateSearchTagTimeout = null
      }, 3000)
    },
    async getUserTagList(query) {
      var response = await api.getUserTagList({
        limit: 100,
        offset: 0,
        filter_name: query || undefined
      })
      if (response && response.result) {
        return response.result.map((item) => {
          return item.name
        })
      } else return []
    },
    async getUserStatusList(query) {
      var response = await api.getUserStatusList({
        limit: 100,
        offset: 0,
        filter_name: query || undefined
      })
      if (response && response.result) {
        return response.result.map((item) => {
          return item.name
        })
      } else return []
    },
    putusercardnumber(type, payload) {
      var vm = this
      this.$set(this.user, type, payload.customer_value)

      vm.$store.dispatch('loading')
      var data = {
        body: {
          usersid: this.user.id,
          cardnumber: payload.customer_value
        },
        params: {
          pageid: this.user.pageid
        }
      }
      api.putusercardnumber(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
        vm.$forceUpdate()
      })
    },
    putusergender(type, payload) {
      var vm = this
      this.$set(this.user, type, payload.customer_value)
      this.$emit('update:gender', this.user)
      vm.$store.dispatch('loading')
      var data = {
        body: {
          gender: payload.customer_value.value
        },
        params: {
          usersid: this.user.id,
          pageid: this.user.pageid
        }
      }
      api.putusergender(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
        vm.$forceUpdate()
      })
    },
    putuserrealname(type, payload) {
      var vm = this
      this.$set(this.user, type, payload.customer_value)

      vm.$store.dispatch('loading')
      var data = {
        body: {
          usersid: this.user.id,
          realname: payload.customer_value
        },
        params: {
          pageid: this.user.pageid
        }
      }
      api.putuserrealname(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
        vm.$forceUpdate()
      })
    },
    editTag() {
      this.isEditTag = true
      this.cached_tag = JSON.parse(JSON.stringify(this.user.tags))
    },

    saveSahapanUserProfile(type, payload) {
      var vm = this
      this.$set(this.user, type, payload.customer_value)
      vm.$store.dispatch('loading')
      var data = {
        lineid: this.user.id,
        firstname: this.user.realfirstname,
        lastname: this.user.reallastname,
        gender: this.user.gender,
        address: this.user.address,
        dob: this.user.dob ? moment(this.user.dob).format() : moment().format(),
        phoneno: this.user.phoneno,
        email: this.user.email
      }
      api.saveSahapanUserProfile(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
        vm.$forceUpdate()
      })
    },
    toggleBotStatus: async function () {
      var vm = this
      let bot = Object.assign({}, vm.selectedBot)
      bot.status = !bot.status
      vm.$store.dispatch('loading')
      await vm.$store.dispatch('toggleBotStatus', bot)
      vm.$store.dispatch('loading')
    },
    getuserDetail() {
      let vm = this
      let data = {
        pageid: this.user.pageid ? this.user.pageid : this.selectedBot.pageid,
        userid: vm.value.id ? vm.value.id : vm.value
      }

      if (!this.loaduser) {
        vm.loading = false
        vm.user = vm.value
        vm.setPhoneForMtcUser(vm.user.id)
        vm.setUserSession(vm.user.session)
      } else if (this.getuseronly) {
        api.getUserOnly(data, function (error, response) {
          if (error) console.error(error)
          vm.user = response.data[0]
          vm.setPhoneForMtcUser(vm.user.id)
          vm.setUserSession(vm.user.session)
          vm.loading = false
        })
      } else {
        api.getUserOnly(data, function (error, response) {
          if (error) console.error(error)
          vm.user = response.data[0]
          var realname = response.data[0].realname ? response.data[0].realname.split(' ') : ''
          vm.user.realfirstname = realname.length > 0 ? realname[0] : ''
          vm.user.reallastname = realname.length > 1 ? realname[1] : ''
          vm.user.dob = vm.user.dob
            ? moment(vm.user.dob).format('YYYY-MM-DD')
            : moment().format('YYYY-MM-DD')
          vm.setPhoneForMtcUser(vm.user.id)
          if (vm.selectedBot.theme == 'toa') {
            Object.assign(vm.user, JSON.parse(vm.user.json_variable))
          }

          vm.setUserSession(vm.user.session)
          vm.loading = false
        })
      }
    },
    setPhoneForMtcUser(phone) {
      if (this.selectedBot && ['mtc'].includes(this.selectedBot.type) && !this.user.phoneno) {
        this.user.phoneno = phone
      }
    },
    setUserSession(session) {
      if (session) {
        try {
          this.userSession = JSON.parse(session)
        } catch (e) {
          this.userSession = session
        }
      }
    },
    editSession() {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        params: {
          pageid: this.user.pageid
        },
        body: {
          usersid: this.user.id,
          session: this.userSession || ''
        }
      }
      api.saveusersession(data, (error, response) => {
        if (response.responsecode == 200) {
          vm.$store.dispatch('loading')
          this.isEditSession = false
        }
        if (error) {
          vm.$store.dispatch('loading')
          vm.$swal.fire({
            title: 'เกิดข้อผิดพลาด',
            text: 'กรุณาลองใหม่อีกครั้ง',
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
        }
      })
    },
    deleteSession(key) {
      delete this.userSession[key]
      this.isEditSession = false
      this.isEditSession = true
    },
    cancleEditSession() {
      this.setUserSession(this.user.session)
      this.isEditSession = false
    },
    onEditAddress(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        address: payload.customer_value || ''
      }
      api.saveUserAddress(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditContext(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        context: payload.customer_value || ''
      }
      api.saveUserContext(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditNote(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        temp_msg: payload.customer_value || ''
      }
      api.saveUserNote(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditCustomRealname(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        customrealname: payload.customer_value || ''
      }
      api.saveCustomerRealName(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    saveEditTag: function () {
      var vm = this
      var data = {
        pageid: this.user.pageid,
        usersid: vm.user.id,
        tags: vm.user.tags || ''
      }
      api.saveUserTags(data, function (error) {
        if (error) {
          console.error(error)
        }
        vm.cached_tag = vm.user.tags
        vm.isEditTag = false
      })
    },
    cancelEditTag: function () {
      this.user.tags = this.cached_tag
      this.isEditTag = false
    },
    onFailLoad: function () {
      this.$set(this.user, 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getFormatDate: function (date, format) {
      return moment(date).format(format)
    },
    addUserTags: function (newTags) {
      this.usertags = newTags
    },
    checkUserTags(obj) {
      this.errorTag = []
      if (obj.tag.text.length > 25) {
        this.errorTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    onEditStatus: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        status: payload.customer_value || ''
      }
      api.saveUserStatus(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditLineId: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        lineid: payload.customer_value || ''
      }
      api.saveUserLineId(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditSchool: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        school: payload.customer_value || ''
      }
      api.saveUserSchool(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditProvince: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        province: payload.customer_value || ''
      }
      api.saveUserProvince(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditEmail: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        email: payload.customer_value || ''
      }
      api.saveUserEmail(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditPhone: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        phoneno: payload.customer_value || ''
      }
      api.saveUserPhoneno(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    getMemberToa() {
      // console.log(this.value.id)
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          userid: this.user.id,
          offset: 0
        }

        api.getmembertoacrm(data, (err, response) => {
          if (response.responsecode == 200) {
            var res = response.data
            const result = res.find((obj) => obj.userid === this.user.id)

            if (result) {
              this.toacrmUser.email = result.email
              this.toacrmUser.phone = result.phone_number
            }
            resolve(response.data)
          }
        })
      })
    },
    goToLivechat: function (user, app) {
      let routeData = this.$router.resolve({
        name: 'livechat',
        path: '/' + this.currentLang + '/livechat',
        query: {
          userid: user.id,
          user: user.context == 'contactadmin' ? 'admin' : 'bot',
          app: app
        }
      })
      window.open(routeData.href, '_blank')
    },
    async handleGetVerandaSatisfactionHistory() {
      const vm = this
      try {
        const data = {
          page_id: vm.selectedBot.pageid,
          user_id: vm.value.id ? vm.value.id : vm.value,
          limit: vm.limit,
          offset: vm.offset
        }
        const response = await verandaApi.getAnalyticSatisfactionHistory({
          config: {
            params: data
          }
        })

        if (response && response.status === 200) {
          vm.satisfactionHistory = response.data.data
          vm.total = response.data.total
        }
      } catch (error) {
        console.error(error)
      }
    },
    handleChangePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        if (vm.pageNumber != 1) {
          vm.offset + 1
        }
        vm.handleGetVerandaSatisfactionHistory()
      }
    }
  },
  watch: {
    // value: function() {
    //   this.user = this.value
    // }
    value: function (newVal, oldVal) {
      var vm = this
      if (newVal == null) {
        vm.user = undefined
      } else if (newVal !== null && newVal != oldVal) {
        vm.user = vm.value
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/dashboard/customer/CustomerDetail.js